import React, { useEffect } from 'react'
import Header2 from '../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import Blogs from '../components/blogs/Blogs'

const BlogsPage = () => {
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
    return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>software development & digital marketing agency in Germany - IT Junction </title>
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <div style={{ overflow:'hidden', backgroundImage:'url("bg-img/MicrosoftTeams-image.webp")', width:'100%', position:'', backgroundAttachment:'fixed'}}>
        <Blogs/>
    </div>
    </>
  )
}

export default BlogsPage